<script setup lang="ts">
    import { Button, type ButtonVariants } from '@/components/ui/button';
    import { DialogClose, DialogFooter } from '@/components/ui/dialog';
    import { cn } from '@/lib/utils';
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();

    const props = withDefaults(
        defineProps<{
            form: any;
            type: 'create' | 'update';
            class?: string;
            submitText?: string;
            submitVariant?: ButtonVariants['variant'];
        }>(),
        {
            submitVariant: 'default',
        },
    );

    const emit = defineEmits(['close']);

    const submitText = computed(() => {
        return t(props.submitText || `forms.${props.type}`);
    });
</script>

<template>
    <DialogFooter :class="cn('gap-2 border-t sm:justify-center', props.class)">
        <slot />

        <DialogClose as-child>
            <Button
                variant="outline"
                size="sm"
                @click="emit('close')"
            >
                {{ $t('forms.cancel') }}
            </Button>
        </DialogClose>

        <Button
            :disabled="form.processing"
            :loading="form.processing"
            size="sm"
            :variant="submitVariant"
        >
            {{ submitText }}
        </Button>
    </DialogFooter>
</template>
